$(function () {
  const host = "https://dip.sylvoxtv.com/api/api";
  const picHost = "https://dip.sylvoxtv.com/";
  // 缩略图点击预览大图
  $("#tableBody").on("click", ".multiImgPreview img", function (e) {
    var src = $(this).attr("src");
    $("#imgViewBig").attr("src", src);
    $("#imgViewModal").fadeIn(120);
  });
  $("#tableBody").on("click", ".sigle-thumbnail img", function (e) {
    var src = $(this).attr("src");
    $("#imgViewBig").attr("src", src);
    $("#imgViewModal").fadeIn(120);
  });
  $("#imgViewClose").on("click", function () {
    $("#imgViewModal").fadeOut(120);
  });
  var tableList = [];
  var statusList = {
    0: "Under Review",
    1: "Approved",
    2: "Supplement",
  };
  function getTableList() {
    // $(".table-loading").show();
    PageLoader.show();
    $.ajax({
      url: host + "/warranty",
      method: "GET",
      data: {
        userEmail: $("#userEmail").val(),
      },
      success: function (res) {
        $("#tableBody").empty();
        if (res.Code == 0) {
          tableList = res.Data;
          if (tableList.length > 0) {
            Array.from(tableList).forEach((item, index) => {
              var innerHtml = `
                  <tr class="table-body" data-index="${index}">
                      <td style="padding-left:10px;">${item.saleOrder}</td>
                      <td><div class="sigle-thumbnail">${
                         item.originalPictureUrl ? `<img class="single-thumbnail-img" src="${ item.originalPictureUrl }" alt="">` : `<svg style="width:100%;height:60px;" t="1749179750338" class="icon" viewBox="0 0 1463 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4616" width="256" height="0"><path d="M1391.774648 0H72.112676A72.112676 72.112676 0 0 0 0 72.112676v879.774648a72.112676 72.112676 0 0 0 72.112676 72.112676h1319.661972a72.112676 72.112676 0 0 0 72.112676-72.112676V72.112676a72.112676 72.112676 0 0 0-72.112676-72.112676zM595.434366 183.670986c58.819906 0 107.135399 49.012582 107.135399 108.553615 0 60.093897-47.618404 108.553615-107.135399 108.553615-58.819906 0-107.183474-48.339531-107.183474-108.553615 0-59.541033 48.363568-108.553615 107.183474-108.553615z m695.094085 704.733145H173.382911c-30.119061 0-40.623474-19.614648-23.124132-44.132957L393.975587 503.202254c17.499343-24.51831 46.200188-24.51831 63.723568 0l132.374836 184.896901 273.138779-377.389671c17.42723-24.662535 46.2723-24.662535 63.747606-0.120188l386.668169 533.633803c17.451268 24.566385 7.018967 44.181033-23.100094 44.181032z" fill="#e6e6e6" p-id="4617"></path></svg>`
                      }</div></td>
                      <td>
                          <div class="thumbnail-container multi-thumbnails multiImgPreview">
                              ${
                                item.orderPicList.length > 0
                                  ? item.orderPicList
                                      .map(
                                        (img) =>
                                          `<img src="${picHost + img}" alt="">`
                                      )
                                      .join("")
                                  : `<svg style="width:100%;height:60px;" t="1749179750338" class="icon" viewBox="0 0 1463 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4616" width="256" height="0"><path d="M1391.774648 0H72.112676A72.112676 72.112676 0 0 0 0 72.112676v879.774648a72.112676 72.112676 0 0 0 72.112676 72.112676h1319.661972a72.112676 72.112676 0 0 0 72.112676-72.112676V72.112676a72.112676 72.112676 0 0 0-72.112676-72.112676zM595.434366 183.670986c58.819906 0 107.135399 49.012582 107.135399 108.553615 0 60.093897-47.618404 108.553615-107.135399 108.553615-58.819906 0-107.183474-48.339531-107.183474-108.553615 0-59.541033 48.363568-108.553615 107.183474-108.553615z m695.094085 704.733145H173.382911c-30.119061 0-40.623474-19.614648-23.124132-44.132957L393.975587 503.202254c17.499343-24.51831 46.200188-24.51831 63.723568 0l132.374836 184.896901 273.138779-377.389671c17.42723-24.662535 46.2723-24.662535 63.747606-0.120188l386.668169 533.633803c17.451268 24.566385 7.018967 44.181033-23.100094 44.181032z" fill="#e6e6e6" p-id="4617"></path></svg>`
                              }
                          </div>
                      </td>
                      <td class="table-mobile">
                         ${
                           item.materialSn.length > 0
                             ? item.materialSn
                                 .map(
                                   (sn) =>
                                     `<div style="margin-bottom: 4px;">${sn}</div>`
                                 )
                                 .join("")
                             : `<p style="text-align:center;margin:0;">-</p>`
                         }
                      </td>
                      <td class="table-mobile">${
                       item.activeStatus > 1 ? '<a class="addDocs" data-index="'+index+'">'+ statusList[item.activeStatus] +'</a>' : statusList[item.activeStatus]
                      }</td>
                      <td>${item.baseServe || `<p style="text-align:center;margin:0;">-</p>`}${item.baseServe > 1 ? 'years' : 'year'}</td>
                      <td class="table-mobile">${item.activeDate}</td>
                      <td class="table-mobile" style="display:none;min-width:20px;text-align:center;">&gt;</td>
                      <td>${item.OverDate}</td>
                      <td style="padding-right:10px;">${item.addServices || `<p style="text-align:center;margin:0;">-</p>`}</td>
                  </tr>
              `;
              $("#tableBody").append(innerHtml);
            });
            var image = $('.single-thumbnail-img')
            errorImgage(image)
          } else {
            $("#tableBody").append(`
                <tr class="table-body">
                    <td class="table-mobile" colspan="10" style="text-align: center;">No data</td>
                </tr>
            `);
          }
        } else {
          $("#tableBody").append(`
            <tr class="table-body">
                <td class="table-mobile" colspan="10" style="text-align: center;">No data</td>
            </tr>
        `);
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        $("#tableBody").empty();
        $("#tableBody").append(`
            <tr class="table-body">
                <td class="table-mobile" colspan="10" style="text-align: center;">No data</td>
            </tr>
        `);
        tableList = [];
        showToast("Error Failed");
      },
      complete: function () {
        // 隐藏 loading
        // $(".table-loading").hide();
        PageLoader.hide();
        
      },
    });
  }
  getTableList();
  $(".custom-table").on("click", "tr",async function () {
    if (isMobile()) {
      var index = $(this).attr("data-index");
      var imgError = false
      if(tableList[index].originalPictureUrl){
        imgError = await checkImageWithImageObject(tableList[index].originalPictureUrl)
        console.log(imgError)
      }
      var innerHtml = `
         <div class="modal-text-item">
                <p class="modal-text-item-title">Order ID</p>
                <span class="modal-text-item-content">${
                  tableList[index].saleOrder
                }</span>
            </div>
            <div class="modal-text-item">
                <p class="modal-text-item-title">Serial Number</p>
                <div class="modal-text-item-content">${
                  tableList[index].materialSn.length > 0
                    ? tableList[index].materialSn
                        .map(
                          (sn) => `<div style="margin-bottom: 4px;">${sn}</div>`
                        )
                        .join("")
                    : `<span>-</span>`
                }</div>
            </div> 
         <div class="modal-text-item">
                <p class="modal-text-item-title">Status</p>
                <span class="modal-text-item-content">${
                  statusList[tableList[index].activeStatus]
                }</span>
            </div>
            <div class="modal-text-item">
                <p class="modal-text-item-title">Coverage Period</p>
                <span class="modal-text-item-content">${tableList[index].baseServe || `<span>-</span>`}${tableList[index].baseServe > 1 ? 'years' : 'year'}</span>
            </div>   
        <div class="modal-text-item">
                <p class="modal-text-item-title">Activation Time</p>
                <span class="modal-text-item-content">${
                  tableList[index].activeDate
                }</span>
            </div>
            <div class="modal-text-item">
                <p class="modal-text-item-title">Expiration Time</p>
                <span class="modal-text-item-content">${
                  tableList[index].OverDate
                }</span>
            </div>
        <div class="modal-text-item">
            <p class="modal-text-item-title">Additional Services</p>
            <p class="modal-text-item-content">${tableList[index].addServices || `<span>-</span>`}</p>
        </div>
        <div class="modal-text-item" style="display:block;">
            <p class="modal-text-item-title">Order Diagram</p>
            ${
              imgError || !tableList[index].originalPictureUrl ? `<div style="width:100%;"><svg style="width:49%;height:auto;" t="1749179750338" class="icon" viewBox="0 0 1463 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4616" width="256" height="0"><path d="M1391.774648 0H72.112676A72.112676 72.112676 0 0 0 0 72.112676v879.774648a72.112676 72.112676 0 0 0 72.112676 72.112676h1319.661972a72.112676 72.112676 0 0 0 72.112676-72.112676V72.112676a72.112676 72.112676 0 0 0-72.112676-72.112676zM595.434366 183.670986c58.819906 0 107.135399 49.012582 107.135399 108.553615 0 60.093897-47.618404 108.553615-107.135399 108.553615-58.819906 0-107.183474-48.339531-107.183474-108.553615 0-59.541033 48.363568-108.553615 107.183474-108.553615z m695.094085 704.733145H173.382911c-30.119061 0-40.623474-19.614648-23.124132-44.132957L393.975587 503.202254c17.499343-24.51831 46.200188-24.51831 63.723568 0l132.374836 184.896901 273.138779-377.389671c17.42723-24.662535 46.2723-24.662535 63.747606-0.120188l386.668169 533.633803c17.451268 24.566385 7.018967 44.181033-23.100094 44.181032z" fill="#e6e6e6" p-id="4617"></path></svg></div>` :
              `<div class="sigle-thumbnail-mobile" style=" border: 2px solid #f3f3f3; border-radius: 8px;"><img class="single-thumbnail-img-mobile" src="${
              tableList[index].originalPictureUrl
            }" alt=""></div>`
            }
        </div>
        <div class="modal-text-item" style="display:block;">
            <p class="modal-text-item-title">Order Screenshot</p>
            <div style="display:flex;justify-content: space-between;">${
                  tableList[index].orderPicList
                    .map(
                      (img) =>
                        `<div class="sigle-thumbnail-mobile orderPicList"><img class="single-thumbnail-img-mobile" src="${picHost+img}" alt=""></div>`
                    )
                    .join("")
                }</div>
        </div>
        `;
      $("#modalText").empty();
      $("#modalText").append(innerHtml);
      $("#myModal").fadeIn(120, function () {
        $("#modalText").animate({ scrollTop: 0 }, 300);
      });
    }
  });
  $("#modalClose").on("click", function () {
    $("#myModal").fadeOut(150);
  });
  // Toast 提示框
  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }
  function isMobile() {
    return window.innerWidth <= 768;
  }
  function errorImgage(images){
    for(let img of images){
      img.onerror = function(){
        $(this).parent().append('<svg style="width:100%;height:60;" t="1749179750338" class="icon" viewBox="0 0 1463 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4616" width="256" height="0"><path d="M1391.774648 0H72.112676A72.112676 72.112676 0 0 0 0 72.112676v879.774648a72.112676 72.112676 0 0 0 72.112676 72.112676h1319.661972a72.112676 72.112676 0 0 0 72.112676-72.112676V72.112676a72.112676 72.112676 0 0 0-72.112676-72.112676zM595.434366 183.670986c58.819906 0 107.135399 49.012582 107.135399 108.553615 0 60.093897-47.618404 108.553615-107.135399 108.553615-58.819906 0-107.183474-48.339531-107.183474-108.553615 0-59.541033 48.363568-108.553615 107.183474-108.553615z m695.094085 704.733145H173.382911c-30.119061 0-40.623474-19.614648-23.124132-44.132957L393.975587 503.202254c17.499343-24.51831 46.200188-24.51831 63.723568 0l132.374836 184.896901 273.138779-377.389671c17.42723-24.662535 46.2723-24.662535 63.747606-0.120188l386.668169 533.633803c17.451268 24.566385 7.018967 44.181033-23.100094 44.181032z" fill="#e6e6e6" p-id="4617"></path></svg>')
        this.remove()
      }
    };
  }
  function checkImageWithImageObject(url) {
      return new Promise((resolve, reject) => {
          const img = new Image();
          
          img.onload = function() {
              resolve(false);
          };
          
          img.onerror = function() {
              resolve(true);
          };
          
          img.src = url;
      });
  }
  $("#ScreenshotModalClose").on("click", function () {
    $("#addDocsModal").fadeOut(150);
  });
  var addDocsId = '';
  // 多图片上传及预览
  var multiImgData = [];
  var filesList = []
  var orderPicList = []
  $("#tableBody").on("click", ".addDocs", function (e) {
    e.stopPropagation();
    var index = $('.addDocs').attr('data-index');
    multiImgData = []
    filesList = []
    addDocsId = tableList[index].saleOrder;
    tableList[index].orderPicList.forEach(item=>{
      multiImgData.push(picHost + item);
      filesList.push(item);
    })
     renderMultiImgPreview()
    $('#serial_number').val('');
    $("#addDocsModal").fadeIn(120);
  });
  // 自定义多图上传按钮逻辑
  $("#multiImgPreview").on("click", "#multiUploadBtn", function () {
      if (multiImgData.length === 3) {
          showToast("You can only upload up to 3 images");
          return;
      }
      $("#order_screenshot").click();
  });
  $("#order_screenshot").on("change", function (e) {
      var files = e.target.files;
      if (files.length === 0) return;
      Array.from(files).forEach(function (file, idx) {
          if (file.type.startsWith("image/")) {
              filesList.push(file);
              var reader = new FileReader();
              reader.onload = function (evt) {
                  multiImgData.push(evt.target.result);
                  renderMultiImgPreview();
              };
              reader.readAsDataURL(file);
          }
      });
      $('#multiUploadBtn').removeClass('error-input');
      $(this).val("");
  });
  // 删除图片
  $("#multiImgPreview").on("click", ".img-thumb-del", function (e) {
      e.stopPropagation();
      var idx = $(this).siblings("img").attr("data-idx");
      multiImgData.splice(idx, 1);
      filesList.splice(idx, 1);
      renderMultiImgPreview();
  });
  // 多图预览渲染时保留上传按钮
  function renderMultiImgPreview() {
      var $preview = $("#multiImgPreview");
      $preview.empty();
      multiImgData.forEach(function (data, i) {
          var $box = $('<div class="img-thumb-box"></div>');
          var $img = $("<img>")
              .attr("src", data)
              .css({
                  width: "130px",
                  height: "130px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  cursor: "pointer",
                  border: "1px solid #eee",
              })
              .attr("data-big", data)
              .attr("title", "review")
              .attr("data-idx", i);
          var $del = $(
              '<button class="img-thumb-del" title="delete">×</button>'
          ).attr("data-idx", i);
          $box.append($img).append($del);
          $preview.append($box);
      });
      $preview.append(
          '<div class="multi-upload-btn" id="multiUploadBtn"><svg t="1747823126898" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1493" width="32" height="32"><path d="M1020.192947 541.265648h-460.281325v482.734352h-78.889013V541.265648H3.761254v-78.877563h477.307154V0h78.889013v462.388085h460.281325v78.877563z" fill="#707070" p-id="1494"></path></svg></div>'
      );
  }
  var submitBoolen = false
  $('.submitBtn').on('click',function(){
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    if(!$('#serial_number').val()){
      $('#serial_number').addClass("error-input");
      return 
    }

    if(filesList.length == 0){
      $('#multiUploadBtn').addClass("error-input");
      return 
    }
    submitBoolen = true;
    // 获取表单数据
    var formData = new FormData();
    var fileList = []
    $.each(filesList, function (i, file) {
      if(typeof(file) == 'string'){
        formData.append("orderPicList",file );
      }else{
        fileList.push(file)
        formData.append("files", file);
      }
    });
    formData.append("saleOrder",addDocsId );
    formData.append("materialSn",$('#serial_number').val() );
     // 构造JSONP元数据
    const meta = {
      files: Array.from(fileList).map((f) =>  f.name ),
      callback: "handleUploadResponse",
    };
    formData.append("meta", `jsonpCallback(${JSON.stringify(meta)})`);
    $(".submitBtn").prop("disabled", true).html("Submitting...");
    // 发送请求
    $.ajax({
      url: host + "/editPlatform",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          $("#addDocsModal").fadeOut(150);
          getTableList()
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        submitBoolen = false;
        $(".submitBtn").prop("disabled", false).html("Submit");
      },
    });
  })
  $("#serial_number").on("change", function () {
    $('#serial_number').removeClass("error-input");
  });
  // 产品序列号上传图片
  $("#scanSerialBtn").on("click", function () {
    $("#serialImgInput").click();
  });
  // 选择图片后触发接口并返回结果显示
  $("#serialImgInput").on("change", function (e) {
    if (!e.target.files || !e.target.files[0]) return;
    $("#serialInputLoading").show();
    $("#serialInputLoading").addClass("input-loading-show");
    $("#serial_number").prop("disabled", true);
    var file = $("#serialImgInput")[0].files[0];
    var formData = new FormData();
    formData.append("file", file);
    formData.append("isSn", true);
    // 构造JSONP元数据
    const meta = {
      file: file.name,
      callback: "handleUploadResponse",
    };
    formData.append("meta", `jsonpCallback(${JSON.stringify(meta)})`);
    $("#serial_number").val("");
    $.ajax({
      url: host + "/uploadfile",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          $("#serial_number").val(res.data);
          $('#serial_number').removeClass("error-input");
        } else {
          showToast(res.Msg);
        }
      },
      error: function (error) {
        $("#serial_number").val("");
        showToast("Error Failed");
      },
      complete: function () {
        $("#serialInputLoading").hide();
        $("#serialInputLoading").removeClass("input-loading-show");
        $("#serial_number").prop("disabled", false);
      },
    });
  });
});
